export const CL_LINK = 'www.conquerlocal.com';
export const CL_COMMUNITY_STG_LINK = 'conquer-local-academy.websitepro-staging.com';
export const USER_ONBOARDING = '/user-onboarding';

export const NEXT_URLS = [CL_LINK, CL_COMMUNITY_STG_LINK, USER_ONBOARDING];
